import { makeStyles } from "@material-ui/core/styles";

export const tabsStyles = makeStyles((theme) => ({
  titleModule: {
    color: "#000000",
    fontFamily: "Inter",
    fontSize: theme.typography.pxToRem(30),
    fontWeight: 600,
  },
  newParticipantTabs: {
    "& .MuiTab-root": {
      color: "#000000",
      fontFamily: "Lato",
      fontSize: theme.typography.pxToRem(16),
      fontWeight: "400",
      textTransform: "capitalize",
    },
    "& .MuiTabs-indicator": {
      height: "4px",
      backgroundColor: "#235693",
      borderTopLeftRadius: "100px",
      borderTopRightRadius: "100px",
    },
  },
  divider: {
    height: "2px",
  },
  newTab: {
    "& .Mui-selected": {
      "& path": {
        fill: "#000000",
      },
      "& .MuiTypography-root": {
        color: "#000000",
      },
    },
    "& .MuiDivider-root": {
      display: "none",
    },
    "& .MuiTabs-indicator": {
      height: "4px",
      borderRadius: "0px",
      borderBottom: "3px solid #000000",
      backgroundColor: "transparent",
    },
  },
}));
